export const solarAlternativeSubMenus = [
  {
    link: "#smart-city",
    label: "Smart City",
  },
  {
    link: "#our-values",
    label: "Our Values",
  },
  {
    link: "#mega-projects",
    label: "Mega Projects",
  },
  {
    link: "#agri-solar",
    label: "Agri Solar",
  },
  {
    link: "#power-solutions",
    label: "Power Solutions",
  },
  {
    link: "#solar-micro-grid",
    label: "Solar Micro grid",
  },
  {
    link: "#operations-&-maintenance",
    label: "Operations & Maintenance",
  },
  {
    link: "#industry-benchmarks",
    label: "Industry Benchmarks",
  },
  {
    link: "#remote-monitoring",
    label: "Remote Monitoring",
  },
];
